import http from "@/http"

let modulePath = "master";
const get = function(locale, path, config = {}) {
  return http.get(`${locale}/${modulePath}/${path}`, config);
}

export default  {
  getDistricts(locale) {
    return get(locale, "districts")
  },
  getDistrictRegions(locale) {
    return get(locale, "districtRegions");
  },
  getRegions(locale) {
    return get(locale, "regions")
  },
  getCompanies(locale) {
    return get(locale, "companies")
  },
  getCompanyByCode(locale, code) {
    return get(locale, "company", {
      params: {
        code: code
      }
    })
  },
  getCountries(locale) {
    return get(locale, "countries")
  },
  getCountryByCode(locale, code) {
    return get(locale, "country", {
      params: {
        code: code
      }
    })
  },
  getDistrictByDistrictCode(locale, code) {
    return get(locale, "district", {
      params: {
        districtCode: code,
      },
    });
  },
  getDistrictRegionByDistrictCode(locale, code) {
    return get(locale, "districtRegion", {
      params: {
        districtCode: code,
      },
    });
  },
  getIsMaintenance() {
    return get("en", "maintenance")
  }
}
